import React, { Component } from 'react';
import {
  ComposedChart,
  Line,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
export default class ComposedStackBarLineChart extends Component {
  render() {
    const { data, config, customTooltip } = this.props;
    const { bars = [], lines = [] } = config;
    const Bars = bars.map((barConfig, idx) => (
      <Bar {...barConfig} key={idx}>
        {config.barFn ? config.barFn(data, barConfig) : null}
      </Bar>
    ));
    const Lines = lines.map((lineConfig, idx) => (
      <Line {...lineConfig} key={`lines_${idx.toString()}`} />
    ));

    return (
      <ResponsiveContainer>
        <ComposedChart data={data}>
          {config.gridConfig ? <CartesianGrid {...config.gridConfig} /> : null}
          <XAxis {...config.xAxis} />
          <YAxis {...config.yAxis} />
          <Tooltip
            isAnimationActive={false}
            {...(customTooltip ? { content: customTooltip } : {})}
          />
          {config.legendConfig ? <Legend {...config.legendConfig} /> : null}
          {Bars}
          {Lines}
        </ComposedChart>
      </ResponsiveContainer>
    );
  }
}
